import axios from "axios";
import { baseUrl } from "../config/api-config";

export function updateProfile (data, token) {
    return axios.patch(`${baseUrl}/user`, data, {
        headers: {
            authorization: token
        }
    })
} 